import React from 'react';
import {ThemeProvider} from '@rn-vui/themed';
import {observer} from 'mobx-react-lite';

import PhoneOrEmailVerification from '../../../components/PhoneOrEmailVerification';
import {AppRoute} from '../../../models/AppRoute';
import {AccountScreenAction, RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {useStores} from '../../../stores/use-stores';
import rewardsTheme from '../../../theme/rewardsTheme';
import apiService from '../../../transport/apiService';
import {VerificationFormData} from '../schemas/authSchemas';

const AccountPhoneVerificationScreen = observer(
  ({route, navigation}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_PHONE_VERIFICATION>) => {
    const {userStore} = useStores();

    const onSubmitHandler = async (
      values: VerificationFormData,
      {
        setError,
      }: {setError: (field: 'verification', error: {type: string; message: string}) => void},
    ) => {
      if (route.params?.action === AccountScreenAction.UPDATE) {
        await userStore.updateUserInfo(
          route.params.action,
          userStore.formValues,
          () => {
            userStore.afterUpdateUser();
          },
          error => {
            if (error?.status === 'PHONE_NUMBER_VERIFICATION_FAILED') {
              setError('verification', {
                type: 'manual',
                message: error.message,
              });
            }
          },
          {
            verificationCode: values.verification,
          },
        );
      } else {
        // Assume it's Create User Account flow
        const createSuccess = await userStore.signUpUser(values.verification);

        if (createSuccess) {
          navigation.navigate(AppRoute.ACCOUNT_SUCCESS);
        } else {
          setError('verification', {
            type: 'manual',
            message: 'Wrong code entered. Please try again.',
          });
        }
      }
    };

    return (
      <ThemeProvider theme={rewardsTheme}>
        <PhoneOrEmailVerification
          type="phone"
          phoneNumber={userStore.formValues?.phoneNumber}
          onSubmit={onSubmitHandler}
          onResend={async () => {
            const result = await apiService.sendMobileVerificationCode({
              phoneNumber: userStore.formValues?.phoneNumber,
            });

            return !!result;
          }}
          onBack={() => {
            if (navigation.canGoBack()) {
              navigation.goBack();
            }
          }}
        />
      </ThemeProvider>
    );
  },
);

export default AccountPhoneVerificationScreen;
